import React from "react";
import ReactPlayer from "react-player";

const TrailerCardView = (props) => {
  return (
    <div className="sm:w-[640px] sm:h-[600px] min-w-[360px] w-[360px] h-[400px] relative rounded-xl overflow-hidden ring-1 ring-primary-200 shadow-lg hover:shadow-xl transition-all duration-300">
      {/* THUMBNAIL */}
      {/* light={<img src="https://thegameassembly.com/wp-content/uploads/sites/2/2022/11/nast-bast-i-varlden-2017-the-game-assembly.jpg" alt='Thumbnail'></img>} */}
      <div className="sm:hidden">
        <ReactPlayer
          url={props.trailerUrl}
          controls={true}
          width="360px"
          height="202px"
          playing={false}
          config={{
            youtube: {
              playerVars: { 
                origin: window.location.origin,
                autoplay: 0
              }
            }
          }}
        />
      </div>

      {/* ReactPlayer for smaller screens */}
      <div className="hidden sm:block">
        <ReactPlayer
          url={props.trailerUrl}
          controls={true}
          width="640px"
          height="360px"
          playing={false}
          config={{
            youtube: {
              playerVars: { 
                origin: window.location.origin,
                autoplay: 0
              }
            }
          }}
        />
      </div>
      <div className="relative">
        <div className="relative h-[170px] sm:h-[190px] w-[360px] sm:w-full bg-gradient-to-br from-primary-50 to-primary-100">
          <h2 className="pt-4 font-bold pl-8 text-sm sm:text-lg text-primary-900">{props.title}</h2>
          <h3 className="font-semibold pl-8 text-lg text-secondary-700">{props.subtitle}</h3>
          <div className="text-justify pt-2 px-8 text-[10px] sm:text-sm text-secondary-600">{props.summary}</div>
        </div>
        <div className="relative z-0 h-[28px] sm:h-[50px] bg-gradient-to-r from-primary-200 via-primary-300 to-primary-200 rounded-b-lg shadow-lg"></div>
        <div className="relative mt-[-50px] sm:mt-[-90px] ml-[152px] sm:ml-[280px] z-10 h-[40px] w-[40px] sm:h-[80px] sm:w-[80px] rounded-full bg-white/90 shadow-lg"></div>
        <div
          onClick={() => props.onClickSetCurrentProject(props.projectId)}
          className="relative mt-[-38px] sm:mt-[-73px] ml-[155px] sm:ml-[288px] z-10 h-[35px] w-[35px] sm:h-[65px] sm:w-[65px] flex items-center justify-center rounded-full bg-primary-600 hover:bg-primary-500 text-white cursor-pointer transform hover:scale-105 transition-all duration-300 shadow-lg"
        >
          <h2 className="font-bold text-[11px] sm:text-lg">More</h2>
        </div>
      </div>
    </div>
  );
};

export default TrailerCardView;
